import Component from './InstagramPost.vue'
export default Component
